export const baseData = {
  title: "PRODUCT STATUS"
}